<template>
  <v-container fluid class="px-0 py-0">
    <v-sheet class="px-0 py-0">
      <CommonFieldString
          v-if="enableSearch"
          v-model="search"
          label="Search"
          :clearable="true">
      </CommonFieldString>
      <v-data-table
          :headers="headers || headersAttr"
          dense
          :items="value"
          class="elevation-1"
          :search="search"
          fixed-header
          :height="height"
          hide-default-footer
          :options="options"
      >
        <template v-slot:item.edit="{ item, index }">
          <v-icon small @click="openEditDialog(item, index)" color="edit_icon" class="d-flex justify-center">
            mdi-square-edit-outline
          </v-icon>
        </template>
        <template v-slot:item.group="{ item, index }">
          {{ item.attribute.group }}
        </template>
        <template v-slot:item.name="{ item, index }">
          {{ item.attribute.name }}
        </template>
        <template v-slot:item.shortname="{ item, index }">
          {{ item.attribute.shortname }}
        </template>
        <template v-slot:item.units_name="{ item, index }">
          {{ item.attribute.units_name }}
        </template>
        <template v-slot:item.manual_change="{ item, index }">
          <v-icon v-if="item.manual_change" color="blue">mdi-delta</v-icon>
        </template>
        <template v-slot:item.value="{ item, index }">
          <span v-if="!!item.value" width="30">{{item.value}}{{item.units}}</span>
          <span v-else width="30">
              <v-icon color="orange">mdi-alert</v-icon>
          </span>
        </template>
      </v-data-table>
    </v-sheet>

    <v-dialog
        v-model="dialog"
        persistent
        max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5"></v-card-title>
        <v-card-text>
          <CommonFieldString v-model="attribute.units" label="units"></CommonFieldString>
          <CommonFieldString v-model="attribute.units_symbol" label="units symbol"></CommonFieldString>
          <CommonFieldString v-model="attribute.value" label="value"></CommonFieldString>
          <v-radio-group
              v-model="attribute.value_type"
              row
          >
            <v-radio
                label="Float"
                value="float"
            ></v-radio>
            <v-radio
                label="Integer"
                value="integer"
            ></v-radio>
            <v-radio
                label="Text"
                value="text"
            ></v-radio>
          </v-radio-group>
          <CommonFieldNumber v-if="attribute.value_type=='float'" v-model="attribute.value_float"
                             label="value float"></CommonFieldNumber>
          <CommonFieldNumber v-if="attribute.value_type=='integer'" v-model="attribute.value_integer"
                             label="value integer"></CommonFieldNumber>
          <CommonFieldNumber v-if="attribute.value_type=='text'" v-model="attribute.value_text"
                             label="value text"></CommonFieldNumber>

          <v-checkbox v-model="attribute.manual_change" label="Manual change"></v-checkbox>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="green darken-1"
              text
              @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
              color="green darken-1"
              text
              @click="saveDialog()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CoreSpecAttrComponentDetail from "@/components/CoreComponent/SpecAttrComponent/CoreSpecAttrComponentDetail";
import {v4 as uuidv4} from "uuid";
import fileFunction from "@/commonFunction/fileFunction";
import CommonFieldString from "@/components/Common/CommonFieldString.vue";
import CommonFieldCheck from "@/components/Common/CommonFieldCheck.vue";
import CommonFieldNumber from "@/components/Common/CommonFieldNumber.vue";

export default {
  name: "CoreComponentAttrList",

  props: {
    value: {default: []},
    height: {default: 0},
    headers: {default: null},
    enableSearch: {default: true},
  },

  components: {CommonFieldNumber, CommonFieldCheck, CommonFieldString},

  methods: {
    openEditDialog(item, index) {
      this.attr_index = index
      this.attribute = structuredClone(this.value[this.attr_index])
      this.attribute.manual_change = true
      this.dialog = true
    },

    saveDialog() {
      this.dialog = false
      this.value[this.attr_index] = structuredClone(this.attribute)
      this.$emit('input', structuredClone(this.value))
    }
  },


  mounted() {
  },

  data() {
    return {
      dialog: false,
      attr_index: 0,
      attribute: {},
      options: {
        itemsPerPage: -1,
      },
      search: null,

      headersAttr: [
        {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 10},
        {text: 'manual change', value: 'manual_change', sortable: false, filterable: true, divider: true, width: 50},
        {text: 'group', value: 'group', sortable: false, filterable: true, divider: true, width: 50},
        {text: 'name', value: 'name', sortable: false, filterable: true, divider: true, width: 50},
        // {text: 'shortname', value: 'shortname', sortable: false, filterable: true, divider: true, width: 50},
        // {text: 'units name', value: 'units_name', sortable: false, filterable: true, divider: true, width: 50},
        {text: 'value', value: 'value', sortable: false, filterable: true, divider: true, width: 50},
        // {text: 'display value', value: 'display_value', sortable: false, filterable: true, divider: true, width: 50},
      ]
    }
  },
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>